import type { LeadCloudFileType } from '@econtractor/types';

export const previewTypes = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'avif', 'bmp', 'svg'];

const isCloudFolder = (item: LeadCloudFileType | null | undefined): boolean => Boolean(item?.isFolder && item?.fileName);

const isCloudStoredFile = (item: LeadCloudFileType | null | undefined): boolean =>
    Boolean(item && !item.isFolder && item.publicUrl && item.fileName);

const isCloudEntry = (item: LeadCloudFileType | null | undefined): boolean =>
    isCloudFolder(item) || isCloudStoredFile(item);

export const parseCloudFiles = (raw?: string | LeadCloudFileType[] | null): LeadCloudFileType[] => {
    if (!raw) return [];
    if (Array.isArray(raw)) return raw.filter(isCloudEntry);

    try {
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        return parsed.filter(isCloudEntry);
    } catch {
        return [];
    }
};

export const stringifyCloudFiles = (files: LeadCloudFileType[]): string => JSON.stringify(files);

export const getFileExtension = (fileName: string): string => fileName.split('.').pop()?.toLowerCase() || '';

export const isPreviewImage = (fileName: string): boolean => previewTypes.includes(getFileExtension(fileName));

export const toStoredCloudFile = (file: LeadCloudFileType): LeadCloudFileType => {
    const stored: LeadCloudFileType = {
        fileName: file.fileName,
        contentType: file.contentType,
        fileSize: file.fileSize,
        storageKey: file.storageKey,
        publicUrl: file.publicUrl,
    };
    const folderPath = String(file.folderPath || '');
    if (folderPath) stored.folderPath = folderPath;
    if (file.isFolder) stored.isFolder = true;
    return stored;
};
